import {
  Button,
  Fade,
  FormControlLabel,
  Grid,
  MenuItem,
  Switch,
  TextField,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import frLocale from "date-fns/locale/pt-BR";
import React from "react";
import { SITUACAO_PEDIDO } from "../../../../../utils/PedidoUtil";

const FiltroPedidos = ({
  pesquisa,
  handleChange,
  handleClickBuscarPedido,
  handleDateChange,
  buscando,
  buscaAvancadaOpen,
  handleChangeBuscaAvancadaOpen,
}) => {
  return (
    <>
      <Grid
        size={{
          xs: 6,
          md: 2,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          label="Mesa/Comanda"
          name="mesa"
          value={pesquisa.mesa || ""}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 6,
          md: 4,
        }}
      >
        <TextField
          variant="outlined"
          fullWidth
          label="Nome"
          name="nomeCliente"
          value={pesquisa.nomeCliente || ""}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 6,
          md: 2,
        }}
      >
        <TextField
          variant="outlined"
          select
          label="Pagamento"
          name="status"
          fullWidth
          value={pesquisa.status || "null"}
          onChange={handleChange}
        >
          <MenuItem key="null" value="null">
            Ambos
          </MenuItem>
          <MenuItem key="PAGO" value="PAGO">
            Conta fechada
          </MenuItem>
          <MenuItem key="PENDENTE" value="PENDENTE">
            Conta aberta
          </MenuItem>
        </TextField>
      </Grid>
      <Grid
        align="center"
        size={{
          xs: 6,
          md: 2,
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={buscaAvancadaOpen}
              onChange={handleChangeBuscaAvancadaOpen}
            />
          }
          label="opções"
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 2,
        }}
      >
        <Button
          color="primary"
          fullWidth
          variant="contained"
          size="large"
          disabled={buscando}
          style={{ fontFamily: "Bebas Neue", fontSize: "20px" }}
          onClick={handleClickBuscarPedido}
        >
          {buscando ? "Buscando..." : "Buscar"}
        </Button>
      </Grid>
      <Fade in={buscaAvancadaOpen} style={{ margin: "0px" }}>
        <Grid
          container
          spacing={2}
          style={{ display: `${buscaAvancadaOpen ? "" : "none"}` }}
        >
          <Grid
            size={{
              xs: 12,
              md: 2,
            }}
          >
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={frLocale}
            >
              <DatePicker
                label="Data inicial"
                format="dd/MM/yyyy"
                value={
                  pesquisa?.dataInicial ? new Date(pesquisa.dataInicial) : null
                }
                onChange={(date) => handleDateChange(date, "dataInicial")}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    variant: "outlined",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid
            size={{
              xs: 12,
              md: 2,
            }}
          >
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={frLocale}
            >
              <DatePicker
                label="Data final"
                format="dd/MM/yyyy"
                value={
                  pesquisa?.dataFinal ? new Date(pesquisa.dataFinal) : null
                }
                onChange={(date) => handleDateChange(date, "dataFinal")}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    variant: "outlined",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid
            size={{
              xs: 12,
              md: 4,
            }}
          >
            <TextField
              variant="outlined"
              select
              name="statusIntegracao"
              id="statusIntegracao"
              value={pesquisa.statusIntegracao || ""}
              fullWidth
              onChange={handleChange}
            >
              <MenuItem value="null">Integrados e não integrados</MenuItem>
              <MenuItem value="INTEGRADO">Integrados</MenuItem>
              <MenuItem value="PENDENTE">Não integrados</MenuItem>
            </TextField>
          </Grid>

          <Grid
            size={{
              xs: 12,
              md: 4,
            }}
          >
            <TextField
              variant="outlined"
              select
              name="statusImpressao"
              id="statusImpressao"
              value={pesquisa.statusImpressao || ""}
              fullWidth
              onChange={handleChange}
            >
              <MenuItem value="null">Impressos e não impressos</MenuItem>
              <MenuItem value="IMPRESSO">Impressos</MenuItem>
              <MenuItem value="PENDENTE">Não impressos</MenuItem>
            </TextField>
          </Grid>

          <Grid
            size={{
              xs: 16,
              md: 4,
            }}
          >
            <TextField
              variant="outlined"
              select
              name="situacao"
              id="situacao"
              value={pesquisa.situacao || ""}
              fullWidth
              onChange={handleChange}
            >
              <MenuItem key="null" value="null">
                Situações
              </MenuItem>
              {Object.keys(SITUACAO_PEDIDO).map((SITUACAO) => (
                <MenuItem key={SITUACAO} value={SITUACAO}>
                  {SITUACAO_PEDIDO[SITUACAO]}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid
            size={{
              xs: 16,
              md: 4,
            }}
          >
            <TextField
              variant="outlined"
              select
              name="tipo"
              id="tipo"
              value={pesquisa.tipo || ""}
              fullWidth
              onChange={handleChange}
            >
              <MenuItem value="null">Todos os tipos</MenuItem>
              <MenuItem value="DELIVERY">Delivery</MenuItem>
              <MenuItem value="MESA">Mesa</MenuItem>
              <MenuItem value="COMANDA">Comanda</MenuItem>
              <MenuItem value="SEQUENCIAL">Sequencial</MenuItem>
            </TextField>
          </Grid>

          <Grid
            size={{
              xs: 12,
              md: 4,
            }}
          >
            <TextField
              variant="outlined"
              select
              name="agendado"
              id="agendado"
              value={pesquisa.agendado || ""}
              fullWidth
              onChange={handleChange}
            >
              <MenuItem value="null">Agendados e Não agendados</MenuItem>
              <MenuItem value="AGENDADO">Agendados</MenuItem>
              <MenuItem value="N_AGENDADO">Não agendados</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </Fade>
    </>
  );
};

export default FiltroPedidos;
